import { createContext, useState, Dispatch, SetStateAction, ReactNode } from 'react';
import { CircularProgress } from '@mui/material';
import styles from './Loading.module.scss';

interface LoadingProviderProps {
  children: ReactNode;
}

export const LoadingContext = createContext<Dispatch<SetStateAction<string[]>> | null>(null);

export const Loading = () => {
  return (
    <div className={styles['framework-loading']}>
      <CircularProgress />
    </div>
  );
};

export const LoadingProvider = ({ children }: LoadingProviderProps) => {
  const [loadingStack, setLoadingStack] = useState<string[]>([]);
  return (
    <LoadingContext.Provider value={setLoadingStack}>
      {
        <div className={loadingStack.length > 0 ? undefined : styles['framework-loading-hide']}>
          <Loading />
        </div>
      }
      {children}
    </LoadingContext.Provider>
  );
};
